import { flow } from 'lodash';
import WordBankSelect from './WordBankSelectGroup';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(
  withUserInput,
  withValidation
)(WordBankSelect);



// WEBPACK FOOTER //
// ../core/src/components/WordBankSelect/index.js